import { isValidDate } from "./is-valid-date";
import { getNowDate } from "./get-now-date";
import { getLocalStringDate } from "./get-local-string-date";

const WRONG_HOUR = "24";

const getProvidedDateWithCorrectTime = (dateStr: string) => {
  const localDateStr = getLocalStringDate(
    dateStr.replace(/Z/, "").replace(/ /g, "T")
  );

  const [date, time] = localDateStr.split(" ");
  const [hours, min, sec] = time.split(":");

  return hours === WRONG_HOUR ? `${date} 00:${min}:${sec}` : localDateStr;
};

export const getProvidedDate = (dateStr: string): string =>
  isValidDate(dateStr) ? getProvidedDateWithCorrectTime(dateStr) : getNowDate();
